import styled from 'styled-components'
import { COLORS } from '@enums/colors'
import { Dropdown } from '@thriveglobal/thrive-ui-lib'

export const LanguageWrapper = styled.div`
  display: flex;
  width: 100%;
`

export const DropdownWrapper = styled(Dropdown)`
  width: 100%;
`

export const Select = styled.select`
  height: 35px;
  width: 100%;
  color: ${COLORS.neutral};
  padding-left: 5px;
  font-size: 14px;
  border: none;
  user-select: none;
`

// margin-left: 10px;
